import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconVote$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVote extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '56027be2d1655bc12d7e27a06f37fd8a2124bcba', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fac1b3bba81c0485ac010c9be3fb55dddfaaca41', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3d5dca0e333c5289eb6f4e7158c67d8b3e0e0b3d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.37 2c-.354 0-.765.039-1.083.068l-.017.002L2.1 7.24a1.3 1.3 0 0 0-.1.52v3.7c0 .158.069.308.19.41 1.18.87 2.55 1.11 6.44 1.13a.54.54 0 0 0 .4-.18C10.6 10.78 11 9.81 11 8.06a7.3 7.3 0 0 0-.32-2.17.45.45 0 0 0-.5-.3l-2.82.34.34-1.43q.104-.388.11-.79C7.81 2.59 6.97 2 5.37 2m-.08 1.5c.344-.023.688.028 1.01.15v.06l.001.048c-.002.084-.021.167-.148.704l-.063.268-.53 2.25a.5.5 0 0 0 .55.61l3.33-.4c.04.41.06.64.06.87a4.88 4.88 0 0 1-1.35 3.44c-2.43 0-3.78-.17-4.65-.59v-3.1zM16.63 20c.354 0 .765-.039 1.083-.068l.017-.002 2.17-5.17c.069-.165.103-.342.1-.52v-3.7a.53.53 0 0 0-.19-.41c-1.18-.87-2.55-1.11-6.44-1.13a.54.54 0 0 0-.4.18C11.4 11.22 11 12.19 11 13.94a7.3 7.3 0 0 0 .32 2.17c.07.21.282.337.5.3l2.82-.34-.34 1.43a3.3 3.3 0 0 0-.11.79c0 1.12.84 1.71 2.44 1.71m.08-1.5a2.4 2.4 0 0 1-1.01-.15v-.06l-.001-.048c.002-.084.021-.167.148-.704l.063-.268.53-2.25a.5.5 0 0 0-.55-.61l-3.33.4a9 9 0 0 1-.06-.87 4.88 4.88 0 0 1 1.35-3.44c2.43 0 3.78.17 4.65.59v3.1z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-vote", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-vote"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-vote":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVote$1);
            }
            break;
    } });
}

const CosmosIconVote = CosmosIconVote$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVote, defineCustomElement };
